import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import api from '@/lib/api';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_nj-liquor-delivery/artifacts/q14l1b4u_1001594216.jpg";

export default function LegalPage({ pageKey, title }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/content/${pageKey}`).then(r => setContent(r.data.content)).catch(() => {}).finally(() => setLoading(false));
  }, [pageKey]);

  return (
    <div className="min-h-screen bg-[#0B0E14]" data-testid={`legal-page-${pageKey}`}>
      <nav className="fixed top-0 w-full z-50 bg-[#0B0E14]/70 backdrop-blur-xl border-b border-white/10 h-14">
        <div className="h-full max-w-4xl mx-auto px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#94A3B8] hover:text-white"><ArrowLeft className="w-4 h-4" /> Back</Link>
          <div className="flex items-center gap-2">
            <img src={LOGO_URL} alt="" className="w-7 h-7 rounded object-cover" />
            <span className="font-['Playfair_Display'] text-sm text-white">HOBOKEN LIQUOR GROCERY & DELI</span>
          </div>
          <div className="w-16" />
        </div>
      </nav>
      <div className="pt-20 pb-12 max-w-3xl mx-auto px-6">
        <h1 className="font-['Playfair_Display'] text-3xl text-white mb-8">{title}</h1>
        {loading ? (
          <div className="space-y-3">{[1,2,3].map(i => <div key={i} className="bg-[#12151C] rounded h-4 animate-pulse" style={{width: `${70 + i * 10}%`}} />)}</div>
        ) : (
          <div className="prose prose-invert max-w-none">
            {content.split('\n').map((para, i) => (
              <p key={i} className="text-[#94A3B8] font-light leading-relaxed mb-4">{para}</p>
            ))}
            {!content && <p className="text-[#64748B]">Content coming soon. Please check back later.</p>}
          </div>
        )}
      </div>
    </div>
  );
}
